import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as global from '../includes/global';
import { from } from 'rxjs';
import {API_URL} from "../../environments/api-url";
import {
    KmsKeyringBrowser,
    KMS,
    getClient,
    encrypt,
    decrypt,
} from '@aws-crypto/client-browser';
import { toBase64 } from '@aws-sdk/util-base64-browser';

@Injectable({
    providedIn: 'root'
})
export class AWSService {
    credentials = {
        accessKeyId: 'AKIA2H6BY4RZUJWFQDIZ',
        secretAccessKey: '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'
    };
    accessKeyId = this.credentials.accessKeyId;
    secretAccessKey = this.credentials.secretAccessKey;
    private generatorKeyId = 'arn:aws:kms:us-east-1:704244147315:alias/dn-encryption';
    private keyIds = [
        'arn:aws:kms:us-east-1:704244147315:key/fa05dfb4-677a-43d4-9bba-efe33b63b94e',
    ];
    clientProvider: any;
    keyring: any;
    context = {
        stage: 'demo',
        purpose: 'simple demonstration app',
        origin: 'us-west-2',
    }
    constructor() {
        this.clientProvider = getClient(KMS, {
            credentials: {
                accessKeyId: this.accessKeyId,
                secretAccessKey: this.secretAccessKey
            },
        });
        this.keyring = new KmsKeyringBrowser({
            clientProvider: this.clientProvider,
            generatorKeyId: this.generatorKeyId,
            keyIds: this.keyIds,
        });
    }
    public async test() {
        const context = {
            stage: 'demo',
            purpose: 'simple demonstration app',
            origin: 'us-west-2',
        }

        /* Find data to encrypt. */
        const plainText = new Uint8Array([1, 2, 3, 4, 5]);

        /* Encrypt the data. */
        const { result } = await encrypt(this.keyring, plainText, {
            encryptionContext: context,
        });

        /* Log the base64-encoded result
         * so that you can try decrypting it with another AWS Encryption SDK implementation.
         */
        const resultBase64 = toBase64(result);

        const { plaintext, messageHeader } = await decrypt(this.keyring, result);

        /* Grab the encryption context so you can verify it. */
        const { encryptionContext } = messageHeader;
    }

    async check() {
        const context = {
            name: 'khaleeq',
            phone: '+923244190430',
            designation: 'Software engg'
        };
        const enccc = await this.encrypt(context);

        const deccc = await this.decrypt(enccc);

    }

    async encrypt(context = {}) {
        const plainTextaaa = new Uint8Array([1, 2, 3, 4, 5])
        const { result } = await encrypt(this.keyring, plainTextaaa, {
            encryptionContext: context,
        });

        return  result;
    }

    async decrypt(result) {
        const { plaintext, messageHeader } = await decrypt(this.keyring, result);
        return messageHeader.encryptionContext;
    }

    toStringType(obj) {
        Object.keys(obj).forEach(k => {
            if (typeof obj[k] === 'object') {
                return this.toStringType(obj[k]);
            }

            obj[k] = '' + obj[k];
        });

        return obj;
    }
}
